module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAAAXNSR0IArs4c6QAAAPRJREFUKFOFjqFOA1EURM+8bddAsgKFwCDaNCFZsfsTFSARBNEaPgrTChQSROXyAW8TmpA0rcAgUIhNwLTsu6Skm9AGwriZzLlz5b1/BA6AfaAF1EBgWw6IgE/gHXhTWZYPZnYEHO+U/7LPkl7kvb8AToABcPgP/AqMgScVRdFKkqRT1/VAUh/oAu2dAytgbmaTKIrGVVUttC5479tm1nXO9c1sCPR2wJmkUQhhImme5/nqG2xUlmUvhDCUdAZ0NvnCzO6cc6Msy2ZNdwtsliWdA5eb0o2Z3TZLv4LrcDqd7i2Xy1NJV2tvZtdxHN+nafrx87svVANdY02AQ5UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/image/search/open.png
// module id = 5ros
// module chunks = 1